// getUploadedBytes.js
import 'isomorphic-fetch';
import { resourceLog } from './debug.js';

/**
 * Get uploaded size
 * @param {string} resumableURL - resumable url.
 * @param {Blob} file - file blob
 * @return {number|null} previous uploaded bytes. will return null when not get uploaded bytes.
 */

async function getUploadedBytes({ resumableURL, file }) {
  try {
    const response = await fetch(resumableURL, {
      method: 'PUT',
      headers: {
        'Content-Range': `bytes */${file.size}`,
      },
    });

    const { status, headers } = response;

    const isCompleted = status === 200 || status === 201;

    if (isCompleted) {
      return file.size - 1;
    }

    const isResumable = status === 308;

    if (isResumable) {
      const [, , end] = /bytes=([\d]+)-([\d]+)/i.exec(headers.get('range'));

      return Number(end);
    }

    return null;
  } catch (error) {
    resourceLog('error occurred at resource/getUploadedBytes.js', error);

    return null;
  }
}

export default getUploadedBytes;
